<template>
  <v-container fill-height fluid class="background" style="max-height: 100vh;">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar color="#000000">
            <!-- <v-spacer /> -->
            <v-toolbar-title class="white--text"
              >INEGI Energy Metering Platform</v-toolbar-title
            >
            <v-spacer />
            <v-avatar color="tranparent" size="70">
              <img src="../assets/img/inegi_icon.png" />
            </v-avatar>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                prepend-icon="mdi-account"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
              <v-text-field
                ref="password"
                v-model="password"
                :error-messages="passwordErrors"
                :rules="[() => !!password || 'This field is required']"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                label="Password"
                required
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                @keydown.enter="login"
                @click:append="showPassword = !showPassword"
              />
            </v-form>
          </v-card-text>
          <!-- <v-divider class="mt-5" /> -->
          <v-card-actions>
            <v-btn block color="inegi_red" @click="login">Sign in </v-btn>
            <!-- <v-btn block color="success" @click="register">Register </v-btn> -->
          </v-card-actions>
          <v-snackbar v-model="snackbar" color="red" :top="true">
            {{ errorMessages }}
            <v-btn dark flat @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Card from "./material/Card.vue";

export default {
  components: { Card },
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required },
  },

  data: function() {
    return {
      email: "",
      password: "",
      errorMessages: "",
      snackbar: false,
      color: "general",
      showPassword: false,
      emailError: false,
      passwordError: false,
    };
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      this.emailError = errors.length == 0 ? false : true;
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required.");
      this.passwordError = errors.length == 0 ? false : true;
      return errors;
    },
  },

  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    login: function() {
      this.$v.$touch();
      if (this.email == "" || this.password == "") {
        this.errorMessages = "Email and password are required";
        this.snackbar = true;
      } else if (!this.emailError && !this.passwordError) {
        let email = this.email;
        let password = this.password;
        this.$store
          .dispatch("login", { email, password })
          .then(() => this.$router.push("/home"))
          .catch((err) => {
            if (err == 400) {
              this.errorMessages = "Incorrect login credentials";
              this.snackbar = true;
            } else {
              console.log(err);
              this.errorMessages = "There was an error executing the request";
              this.snackbar = true;
            }
          });
      }
    },
    // register: function() {
    //   this.$router.push("/register");
    // },
  },
  metaInfo() {
    return {
      title: "INEGI Admin Platform",
    };
  },
};
</script>

<style scoped>
.background {
  background-color: darkgray;
  width: 100%;
  height: 100%;
}
</style>
